








































import Vue from 'vue';
import {RoutsData} from '../router/routs';
import {VideoApi} from '@/api/video-api';
import {Video} from '@/types/video';

export default Vue.extend({
    name: 'VideoList',
    beforeMount() {
      this.getData();
    },
    data() {
      return {
        video: [] as Video[],
        load: false,
        addVideo: {name: RoutsData.VIDEO_ADD.name}
      };
    },
    methods: {
      async getData() {
        this.load = true;
        VideoApi.getList().then(res => this.video = res.data).finally(() => this.load = false);
      }
    }
  });
